export var FlowFhirEndpoint;
(function (FlowFhirEndpoint) {
    FlowFhirEndpoint["GetPatient"] = "GetPatient";
    FlowFhirEndpoint["PractitionerSearch"] = "PractitionerSearch";
    FlowFhirEndpoint["ListEncounters"] = "ListEncounters";
    FlowFhirEndpoint["BookedAppointments"] = "BookedAppointments";
    FlowFhirEndpoint["LabValues"] = "LabValues";
    FlowFhirEndpoint["ServiceRequests"] = "ServiceRequests";
    FlowFhirEndpoint["Medications"] = "Medications";
    FlowFhirEndpoint["Conditions"] = "Conditions";
    FlowFhirEndpoint["Documents"] = "Documents";
    FlowFhirEndpoint["Binaries"] = "Binaries";
    FlowFhirEndpoint["SurgicalHistories"] = "SurgicalHistories";
    FlowFhirEndpoint["Coverages"] = "Coverages";
})(FlowFhirEndpoint || (FlowFhirEndpoint = {}));
//# sourceMappingURL=enums.js.map